import { Component, Inject } from "@angular/core";
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "Room-edit-dialog",
  templateUrl: "./room-edit-dialog.component.html",
  styleUrls: ["./room-edit-dialog.scss"],
})
export class RoomEditDialogComponent {
  dialogData: any;

  constructor(
    public dialogRef: MatDialogRef<RoomEditDialogComponent>,
    private snackBar: MatSnackBar,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data?.Room) {
      this.dialogData = data.Room;
    }
  }

  ngOnInit() {}

  save() {
    if (!this.dialogData.room_descr?.length || !this.dialogData.dsh_heat_flow) {
      this.snackBar.open(
        `Room Description and Design Airflow CFM Required `,
        "",
        {
          duration: 2000,
        }
      );
    } else {
      this.dialogRef.close(this.dialogData);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
